import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import styled from "styled-components";
import { color } from "style/constants";

interface DraggableProps {
  id: string;
  children: React.ReactNode;
  isDropped: boolean;
  inEditMode: boolean;
}

const Draggable: React.FC<DraggableProps> = ({ id, children, isDropped, inEditMode }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    disabled: !inEditMode
  });

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform)
  };

  return (
    <DraggableContainer
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      isDropped={isDropped}
      inEditMode={inEditMode}
    >
      {children}
    </DraggableContainer>
  );
};

const DraggableContainer = styled.div<{ isDropped: boolean; inEditMode: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: ${props => (props.isDropped ? "" : `1px solid ${color.PALEGRAY}`)};
  background-color: ${props => (props.isDropped ? color.DARKBLUE : color.WHITE)};
  color: ${props => (props.isDropped ? color.WHITE : color.BLACK)};
  cursor: ${props => (props.inEditMode ? "pointer" : "auto")};
  width: fit-content;
`;

export default Draggable;
